document.addEventListener('DOMContentLoaded', () => {
  const stickyAddToCart = document.querySelector('.sticky-add-to-cart');
  const productForm = document.querySelector('.product-form'); // Main product form
  const productFormButton = productForm?.querySelector('[type="submit"]'); // Main Add to Cart button

  if (!stickyAddToCart || !productForm || !productFormButton) return;

  // Ensure the sticky button is hidden initially
  stickyAddToCart.style.display = 'none';
  stickyAddToCart.style.visibility = 'hidden'; // Prevent it from flashing on load

  const toggleStickyButton = () => {
    const rect = productForm.getBoundingClientRect();
    const hasScrolledPast = rect.top < 0; // Check if product-form__buttons has scrolled past the top of the viewport
    const isVisible = rect.bottom >= 0 && rect.top < window.innerHeight;

    // Only show on mobile screens
    if (window.innerWidth <= 749) {
      // Show sticky button only when product-form__buttons has scrolled past and is not visible
      if (hasScrolledPast && !isVisible) {
        stickyAddToCart.style.display = 'block';
        stickyAddToCart.style.visibility = 'visible'; // Make it visible after logic is applied
      } else {
        stickyAddToCart.style.display = 'none';
      }
    } else {
      stickyAddToCart.style.display = 'none'; // Always hide on desktop
    }
  };

  // Handle sticky button click
  stickyAddToCart.addEventListener('click', () => {
    // Trigger the main Add to Cart button's click event
    productFormButton.click();
  });

  // Check on scroll and resize
  window.addEventListener('scroll', toggleStickyButton);
  window.addEventListener('resize', toggleStickyButton);

  // Initial check
  toggleStickyButton();
});
